module.exports = __webpack_public_path__ + "img/1200f.39b79d2b.png";